<div [class]="'partner-card ' + customCss + ' max-md:cbp-border-0 cbcp-card'">
  <ng-content select="[card-body]"></ng-content>
</div>
